import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { EditIcon, CloseCancelErrorIcon, Checkmark3Icon } from "@flat-ui";
import { Box, InputAdornment } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
/** The HTML id for the button that saves the input text */
export const SAVE_TEXT_BTN_ID = "saveTextBtn";

/** The HTML id for the button that clears the input text */
export const CLEAR_TEXT_BTN_ID = "clearTextBtn";

/** Shows icons related to editing a text field */
export function TextFieldControls(t0) {
  const $ = _c(22);
  const {
    isHovered,
    isEditMode,
    isConfirmDisabled: t1,
    paddingRight: t2,
    editButtonSize: t3,
    editIconSize: t4,
    controlButtonSize: t5,
    controlIconSize: t6,
    onEditClicked,
    onCheckClicked,
    onClearClicked
  } = t0;
  const isConfirmDisabled = t1 === undefined ? false : t1;
  const paddingRight = t2 === undefined ? "0px" : t2;
  const editButtonSize = t3 === undefined ? "24px" : t3;
  const editIconSize = t4 === undefined ? "16px" : t4;
  const controlButtonSize = t5 === undefined ? "24px" : t5;
  const controlIconSize = t6 === undefined ? "16px" : t6;
  let t7;
  if ($[0] !== paddingRight) {
    t7 = {
      paddingRight
    };
    $[0] = paddingRight;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: "flex",
      alignItems: "center",
      ml: "auto"
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== editButtonSize || $[4] !== editIconSize || $[5] !== isEditMode || $[6] !== isHovered || $[7] !== onEditClicked) {
    t9 = isHovered && !isEditMode && <SphereIconButton component={EditIcon} buttonSize={editButtonSize} iconSize={editIconSize} onClick={onEditClicked} color={PALETTE_VARS.text.disabled} />;
    $[3] = editButtonSize;
    $[4] = editIconSize;
    $[5] = isEditMode;
    $[6] = isHovered;
    $[7] = onEditClicked;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== controlButtonSize || $[10] !== controlIconSize || $[11] !== isConfirmDisabled || $[12] !== isEditMode || $[13] !== onCheckClicked || $[14] !== onClearClicked) {
    t10 = isEditMode && <><SphereIconButton id={SAVE_TEXT_BTN_ID} component={_temp} buttonSize={controlButtonSize} iconSize={controlIconSize} onClick={onCheckClicked} isDisabled={isConfirmDisabled} /><SphereIconButton id={CLEAR_TEXT_BTN_ID} component={CloseCancelErrorIcon} buttonSize={controlButtonSize} iconSize={controlIconSize} onClick={onClearClicked} /></>;
    $[9] = controlButtonSize;
    $[10] = controlIconSize;
    $[11] = isConfirmDisabled;
    $[12] = isEditMode;
    $[13] = onCheckClicked;
    $[14] = onClearClicked;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <Box sx={t8}>{t9}{t10}</Box>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t7) {
    t12 = <InputAdornment position="end" sx={t7}>{t11}</InputAdornment>;
    $[19] = t11;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function _temp() {
  return <Checkmark3Icon sx={{
    fontSize: "18px",
    color: "primary.main"
  }} />;
}